// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingsList-styles___pageHeaderWrapper--AezSt {
  display: flex;
  justify-content: space-between;
}

.components-BookingsList-styles___clickable--vN9ha {
  cursor: pointer;
}

.components-BookingsList-styles___wideTable--M5IHj .components-BookingsList-styles___tableHead--tlYjA,
  .components-BookingsList-styles___wideTable--M5IHj .components-BookingsList-styles___tableRowCell--Id5Lc {
    padding: 14px 0px 14px 12px !important;
  }

.components-BookingsList-styles___wideTable--M5IHj .components-BookingsList-styles___tableHead--tlYjA:first-child,
  .components-BookingsList-styles___wideTable--M5IHj .components-BookingsList-styles___tableRowCell--Id5Lc:first-child {
    padding: 14px 0px 14px 32px !important;
  }

.components-BookingsList-styles___noBorder--EFOlt {
  border: none !important;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);
}

.components-BookingsList-styles___withBorder--gG1B9 {
  border: 1px solid #dddee0 !important;
}

.components-BookingsList-styles___tableHead--tlYjA {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-BookingsList-styles___tableRow--jAjaY {
  height: auto !important;
}

.components-BookingsList-styles___tableRow--jAjaY:last-child .components-BookingsList-styles___tableRowCell--Id5Lc {
      border: none;
    }

.components-BookingsList-styles___tableRow--jAjaY:hover {
    background: #f6f6f7;
  }

.components-BookingsList-styles___paper--MULuO {
  position: relative;

  box-shadow:
    0px 1px 1px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 3px 1px -2px rgba(0, 0, 0, 0.12);
}

.components-BookingsList-styles___tableRowCell--Id5Lc {
  padding: 14px 20px 14px 20px !important;
  font-size: 15px !important;
  max-width: 220px !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

.components-BookingsList-styles___tableRowCellEmail--jwq8a {
  max-width: 300px !important;
}

.components-BookingsList-styles___tableRowCellBirthDate--QYimL {
  max-width: 70px !important;
}

.components-BookingsList-styles___clickable--vN9ha {
  cursor: pointer;
}

.components-BookingsList-styles___tabs--SYKGI,
.components-BookingsList-styles___tab--CZ4SI {
  text-transform: initial !important;
}

.components-BookingsList-styles___tabs--SYKGI {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 40px;
}

.components-BookingsList-styles___noData--pPh_S {
  padding: 20px;
}

.components-BookingsList-styles___link--e7DO8 {
  cursor: pointer;
  color: #318afb;
  min-width: 80px;
}

.components-BookingsList-styles___tableStyle--niOFZ table td:first-child,
    .components-BookingsList-styles___tableStyle--niOFZ table th:first-child {
      padding: 4px 0px 4px 32px !important;
    }
`, "",{"version":3,"sources":["webpack://./components/BookingsList/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAGE;;IAEE,sCAAsC;EACxC;;AAIA;;IAEE,sCAAsC;EACxC;;AAGF;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AAWzB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,mBAAmB;EACrB;;AAGF;EACE,kBAAkB;;EAElB;;;wCAGsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAII;;MAEE,oCAAoC;IACtC","sourcesContent":[".pageHeaderWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.wideTable {\n  .tableHead,\n  .tableRowCell {\n    padding: 14px 0px 14px 12px !important;\n  }\n}\n\n.wideTable {\n  .tableHead:first-child,\n  .tableRowCell:first-child {\n    padding: 14px 0px 14px 32px !important;\n  }\n}\n\n.noBorder {\n  border: none !important;\n  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);\n}\n\n.withBorder {\n  border: 1px solid #dddee0 !important;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: auto !important;\n\n  &:last-child {\n    .tableRowCell {\n      border: none;\n    }\n  }\n\n  &:hover {\n    background: #f6f6f7;\n  }\n}\n\n.paper {\n  position: relative;\n\n  box-shadow:\n    0px 1px 1px 0px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14),\n    0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n}\n\n.tableRowCell {\n  padding: 14px 20px 14px 20px !important;\n  font-size: 15px !important;\n  max-width: 220px !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tableRowCellEmail {\n  max-width: 300px !important;\n}\n\n.tableRowCellBirthDate {\n  max-width: 70px !important;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 40px;\n}\n\n.noData {\n  padding: 20px;\n}\n\n.link {\n  cursor: pointer;\n  color: #318afb;\n  min-width: 80px;\n}\n\n.tableStyle {\n  table {\n    td:first-child,\n    th:first-child {\n      padding: 4px 0px 4px 32px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeaderWrapper": `components-BookingsList-styles___pageHeaderWrapper--AezSt`,
	"clickable": `components-BookingsList-styles___clickable--vN9ha`,
	"wideTable": `components-BookingsList-styles___wideTable--M5IHj`,
	"tableHead": `components-BookingsList-styles___tableHead--tlYjA`,
	"tableRowCell": `components-BookingsList-styles___tableRowCell--Id5Lc`,
	"noBorder": `components-BookingsList-styles___noBorder--EFOlt`,
	"withBorder": `components-BookingsList-styles___withBorder--gG1B9`,
	"tableRow": `components-BookingsList-styles___tableRow--jAjaY`,
	"paper": `components-BookingsList-styles___paper--MULuO`,
	"tableRowCellEmail": `components-BookingsList-styles___tableRowCellEmail--jwq8a`,
	"tableRowCellBirthDate": `components-BookingsList-styles___tableRowCellBirthDate--QYimL`,
	"tabs": `components-BookingsList-styles___tabs--SYKGI`,
	"tab": `components-BookingsList-styles___tab--CZ4SI`,
	"noData": `components-BookingsList-styles___noData--pPh_S`,
	"link": `components-BookingsList-styles___link--e7DO8`,
	"tableStyle": `components-BookingsList-styles___tableStyle--niOFZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
